import { render } from "./Gameboard_SidePanels_2.vue?vue&type=template&id=3cbf4f60"
import script from "./Gameboard_SidePanels_2.vue?vue&type=script&lang=js"
export * from "./Gameboard_SidePanels_2.vue?vue&type=script&lang=js"

import "./Gameboard_SidePanels_2.vue?vue&type=style&index=0&id=3cbf4f60&lang=css"
script.render = render

export default script